export const GIF_PAGE_SIZE = 20;

export const GIF_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  BANNED: 'BANNED',
};

export const GIF_STATUS_OPTIONS = [
  { value: '', label: '全部' },
  { value: GIF_STATUS.ACTIVE, label: '上架' },
  { value: GIF_STATUS.INACTIVE, label: '下架' },
  { value: GIF_STATUS.BANNED, label: '封禁' },
];

export const GIF_STATUS_FORM_OPTIONS = GIF_STATUS_OPTIONS.filter((o) => o.value);

export function buildGifPackPageParams(pageNo, filters = {}, pageSize = GIF_PAGE_SIZE) {
  const params = { pageNo, pageSize };
  if (filters.status) {
    params.status = filters.status;
  }
  if (filters.name?.trim()) {
    params.name = filters.name.trim();
  }
  return params;
}

export function formatGifStatus(status) {
  const found = GIF_STATUS_FORM_OPTIONS.find((o) => o.value === status);
  return found?.label || status || '—';
}

export const ACCESS_TYPE_OPTIONS = [
  { value: 'FREE', label: 'FREE' },
  { value: 'VIP_SUBSCRIPTION', label: 'VIP_SUBSCRIPTION' },
  { value: 'CREATOR_SUBSCRIPTION', label: 'CREATOR_SUBSCRIPTION' },
  { value: 'PERMANENT_PURCHASE', label: 'PERMANENT_PURCHASE' },
  { value: 'LIMITED_EVENT', label: 'LIMITED_EVENT' },
  { value: 'CUSTOM', label: 'CUSTOM' },
];

export const EMPTY_PACK_FORM = {
  name: '',
  accessType: 'FREE',
  coverObjectKey: '',
  description: '',
  status: GIF_STATUS.ACTIVE,
  sort: 0,
  tags: '',
};

export const EMPTY_GIF_FORM = {
  emoteCode: '',
  name: '',
  objectKey: '',
  previewObjectKey: '',
  mimeType: 'image/gif',
  width: 240,
  height: 240,
  fileSize: '',
  durationMs: '',
  status: GIF_STATUS.ACTIVE,
  sort: 0,
  tags: '',
  description: '',
};
